import { gql } from '@apollo/client';

//Update this!
export const GET_CHAT_SERVER_URL = gql`
  query GET_CHAT_SERVER_URL($originatorId: ID!){
    getChatServerUrl(originatorId: $originatorId) {
     url
     args
  }
}
`;